<div style="width: 100%;">
  <mat-tab-group animationDuration="0ms" style="width: 100%" [selectedIndex]="selected" (selectedIndexChange)="go($event)">
    @for (tab of tabs; track tab) {
      <mat-tab [label]="tab">
        <div style="padding-bottom: 2rem">
          @switch(tab) {
            @case ("users") {
              <app-users></app-users>
            }
            @case ("organizations") {
              <app-organizations></app-organizations>
            }
            @case ("cohorts") {
              <app-cohorts></app-cohorts>
            }
            @case ("allotments") {
              <app-allotments></app-allotments>
            }
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>